// Retained Net Income record -> react-select option for the Profit
// Distribution modal
export const toRetainedNetIncomeOption = (record) => ({
  value: record.id,
  label: record.name,
  transaction_number: record.transaction_number,
  from: record.from,
  to: record.to,
});
